// extracted by mini-css-extract-plugin
export default {"root":"IssuesSummary_root__nTGgb","wrapper":"IssuesSummary_wrapper__xlxID"};